import { ParsedUrlQuery } from 'querystring';

export function getDuration(query: ParsedUrlQuery) {
    if (query['duration']) {
        return query['duration'];
    }

    return '';
}
